<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L10.5 6M6 6L2 6"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 14L14.5 14M10.2416 14L2 14"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 5.99988C10.5 4.89531 9.60457 3.99988 8.5 3.99988C7.39543 3.99988 6.5 4.89531 6.5 5.99988C6.5 7.10445 7.39543 7.99988 8.5 7.99988C9.60457 7.99988 10.5 7.10445 10.5 5.99988Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 14C14.5 12.8954 13.6046 12 12.5 12C11.3954 12 10.5 12.8954 10.5 14C10.5 15.1046 11.3954 16 12.5 16C13.6046 16 14.5 15.1046 14.5 14Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'FilterIcon'
}
</script>
